import { RADIO_ICON_PX } from 'theme/components/radio-icons';
import { SELECTION_CONTROL_PADDING_PX } from 'theme/components/selection-control';
import type { RadioGroupSize } from 'ui/radio-group/radio-group.types';

const FIGMA_SPACING_PX = {
  medium: { labelToOptions: 4, betweenRows: 2, betweenColumns: 12 },
  small: { labelToOptions: 4, betweenRows: 4, betweenColumns: 8 },
} as const satisfies Record<RadioGroupSize, Record<string, number>>;

const OPTION_LINE_HEIGHT_PX = {
  medium: 24,
  small: 20,
} as const satisfies Record<RadioGroupSize, number>;

const haloOverflowPx = (size: RadioGroupSize) =>
  (RADIO_ICON_PX[size] +
    2 * SELECTION_CONTROL_PADDING_PX[size] -
    OPTION_LINE_HEIGHT_PX[size]) /
  2;

const gapsFor = (size: RadioGroupSize) => ({
  stack: FIGMA_SPACING_PX[size].labelToOptions + haloOverflowPx(size),
  betweenRows: FIGMA_SPACING_PX[size].betweenRows + 2 * haloOverflowPx(size),
  betweenColumns:
    FIGMA_SPACING_PX[size].betweenColumns + SELECTION_CONTROL_PADDING_PX[size],
});

export const RADIO_GROUP_GAP_PX = {
  medium: gapsFor('medium'),
  small: gapsFor('small'),
} as const satisfies Record<RadioGroupSize, ReturnType<typeof gapsFor>>;
